import type { ConversionModuleConfig } from '../../types/modules/conversion';

function dataTrackSource(
  event: string,
  trigger: 'click' | 'hover' | 'visible'
) {
  return {
    name: trigger === 'click' ? event : `${event}:${trigger}`,
    type: 'selector' as const,
    selector: `[data-track="${event}"]`,
    selectorType: 'css' as const,
    trigger,
  };
}

function dataTrackDetector(event: string) {
  return {
    enabled: true,
    sources: [dataTrackSource(event, 'click')],
  };
}

export const DEFAULT_CONVERSION_MODULE_CONFIG: ConversionModuleConfig = {
  enabled: true,

  manual: {
    pageView: {
      enabled: true,
    },
    purchase: {
      enabled: true,
    },
    lead: {
      enabled: true,
    },
    addToCart: {
      enabled: true,
    },
    removeFromCart: {
      enabled: true,
    },
    initiateCheckout: {
      enabled: true,
    },
    addPaymentInfo: {
      enabled: true,
    },
    search: {
      enabled: true,
    },
    viewContent: {
      enabled: true,
    },
  },

  auto: {
    enabled: true,

    detectors: {
      lead: dataTrackDetector('lead'),
      addToCart: dataTrackDetector('add_to_cart'),
      removeFromCart: dataTrackDetector('remove_from_cart'),
      initiateCheckout: dataTrackDetector('initiate_checkout'),
      purchase: dataTrackDetector('purchase'),
      addPaymentInfo: dataTrackDetector('add_payment_info'),
      search: dataTrackDetector('search'),
      viewContent: {
        enabled: true,
        sources: [
          dataTrackSource('view_content', 'click'),
          dataTrackSource('view_content', 'hover'),
          dataTrackSource('view_content', 'visible'),
        ],
      },
    },
  },

  rules: {
    enabled: false,
    selectors: ['[data-track]'],
    texts: ['Comprar', 'Comprar Agora', 'Finalizar Compra', 'Checkout'],
    urlPatterns: ['thank-you', 'purchase', 'success', 'order', 'checkout'],
    checkout: {
      enabled: false,
    },
    card: {
      enabled: false,
    },
  },
};
